import React from 'react';

const CustomAlertTemplate = ({ style, options, message, close }) => (
    <>
    {/* {options.type = "info"} */}
  <div
    className={`custom-alert-container ${options.type}`}
  >
    {/* {console.log("options=",options)} */}
    {
        options.type == "info" ? 
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E9AFE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight:"20px",minWidth:"24px"}}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>
        :
        options.type == "error" ? 
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FF0040" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight:"20px",minWidth:"24px"}}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg>
        : //options.type == "success"
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#31B404" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight:"20px",minWidth:"24px"}}><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
    }
    <span style={{flex: "2 1 0%"}}>{message}</span>
    <button onClick={close} style={{marginLeft:"20px",border:"none",backgroundColor:"transparent",cursor: "pointer"}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style={{marginRight:"0px",minWidth:"24px"}}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    </button>
  </div>
  </>
);

export default CustomAlertTemplate;
